import { makeStyles, fade } from '@material-ui/core/styles';

const drawerWidth = 0;

export default makeStyles((theme) => ({
  appBar: {
    // boxShadow: 'none',
    // borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    boxShadow: 'rgb(43 52 69 / 10%) 0px 4px 16px',
    color: 'inherit',
    padding: '3px 0px',
    background: '#fff',
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    }
  },

  form: {
    width: '80%',
    [theme.breakpoints.up('901')]: {
      width: '60%',
    },
  },
  formControl: {
    width: '100%'
  },

  searchInput: {
    borderRadius: '30px',
    padding: '0px',
  },

  searchButton: {
    color: 'rgb(55, 63, 80)',
    background: '#F6F9FC',
    height: '3.5rem',
    borderRadius: '30px',
    padding: '0px 15px'
  },

  shoppingCart: {
    [theme.breakpoints.down('901')]: {
      display: 'none'
    }
  },

  Toolbar: {
    flexGrow: 1,
    display: 'flex',
    width: '88%',
    margin: 'auto',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
      margin: '0px'
    },
    [theme.breakpoints.down('901')]: {
      justifyContent: 'center',
    },
  },

  title: {
    // flexGrow: 1,
    alignItems: 'center',
    display: 'flex',
    textDecoration: 'none',
    color: 'inherit',
    width: 'auto',
  },

  span: {
    font: 'Roboto, sans-serif',
    fontSize: '30px',
    fontWeight: '600',
    backgroundImage: 'linear-gradient(315deg, #f7b42c 0%, #fc575e 74%)',
    '-webkit-background-clip': 'text',
    '-webkit-text-fill-color': 'transparent',
    [theme.breakpoints.down('768')]: {
      fontSize: '25px',
      fontWeight: '400',
    }

  },

  image: {
    height: '40px',
    borderRadius: '50%',
    [theme.breakpoints.down('768')]: {
      height: '30px',
    }
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      // display: 'none',
    },
  },
  grow: {
    flexGrow: 1,
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
}));